var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.2 17.4",
    xmlSpace: "preserve",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.4,6.2c0.2,0.2,0.2,0.6,0,0.9c-0.4,0.4-0.8,0.7-1.1,1.1c-1,1-2.1,1.9-3.1,2.9c-0.2,0.2-0.4,0.3-0.7,0.3 c-0.1,0-0.2-0.1-0.3-0.2c-0.7-0.7-1.5-1.5-2.2-2.2C4.8,8.8,4.7,8.6,4.7,8.4c0-0.2,0.2-0.5,0.4-0.6C5.3,7.8,5.5,7.8,5.7,8 C6.2,8.4,6.6,8.9,7,9.3c0.2,0.2,0.3,0.3,0.5,0.5c0.1,0.1,0.1,0.1,0.1,0c1.2-1.1,2.4-2.3,3.6-3.4c0.1-0.1,0.2-0.2,0.2-0.2 C11.8,6,12.1,6,12.4,6.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.6,16.4c-4.2,0-7.7-3.4-7.7-7.7C0.9,4.5,4.4,1,8.6,1s7.7,3.4,7.7,7.7C16.3,12.9,12.8,16.4,8.6,16.4z M8.6,2.3 c-3.5,0-6.4,2.9-6.4,6.4c0,3.5,2.9,6.4,6.4,6.4S15,12.2,15,8.7C15,5.2,12.1,2.3,8.6,2.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4917c081.svg";
export { ForwardRef as ReactComponent };